var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7102 1.45766C10.4658 1.66058 10.2284 1.8859 10 2.13439C9.7716 1.8859 9.53421 1.66058 9.27502 1.44544C2.884 -3.83033 -8.2924 6.16639 10 18C28.2924 6.16639 17.116 -3.83033 10.7102 1.45766ZM10.7362 2.81112C13.2316 0.0963747 17.1826 0.565298 18.5536 3.36718C20.1914 6.71436 17.6058 11.7324 10 16.8037C2.39421 11.7324 -0.191354 6.71436 1.44642 3.36718C2.81738 0.565298 6.76844 0.0963747 9.26377 2.81112L10 3.61208L10.7362 2.81112Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyHeart);
export default __webpack_public_path__ + "static/media/emptyHeart.62b7aca0eb36368268ee1208aca3738b.svg";
export { ForwardRef as ReactComponent };